$(document).ready(function() {
    handleWindowResize();
});

function handleWindowResize() {
   if ($(window).width() < 500) {
      $('.testimonial-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1
      }); 
    }
    else if ($(window).width() < 767) {
      $('.testimonial-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 2,
        slidesToScroll: 1
      }); 
    }
    else if ($(window).width() < 989) {
      $('.testimonial-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1
      }); 
    }
    else if ($(window).width() > 990) {
      $('.testimonial-slider').slick({
        rows: 2,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 4,
        slidesToScroll: 4
      });
    }
}

document.addEventListener("shopify:section:load", function(event) {
  $(document).ready(function() {
      handleWindowResize();
  });
  
  function handleWindowResize() {
    if ($(window).width() < 767) {
      $('.testimonial-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1
      }); 
    }
    else if ($(window).width() < 989) {
      $('.testimonial-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1
      }); 
    }
    else if ($(window).width() > 990) {
      $('.testimonial-slider').slick({
        rows: 2,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1
      });
    }
  }
});

$( document ).ready(function() {
    $('.hero-logos').slick({        
       // rows: 2,
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      // centerMode: true,
      autoplay: true,
      autoplaySpeed: 1,
      speed: 2000,
      cssEase: 'linear',
      slidesToShow: 9,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });
});


 $( document ).ready(function() {
    $(".great-jobs").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow:1,
          }
        }
      ]
    });
  });

 $( document ).ready(function() {
  $(".examples-item-wrap").slick({
    slidesToShow: 3,
    infinite:true,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
      }
      },
      {
      breakpoint: 600,
      settings: {
        slidesToShow:1,
      }
      }
    ]
  });
 });


$(document).ready(function(){
  function initializeSlider() {
    if ($(window).width() <= 767) { 
      if (!$('.tech-role-slider').hasClass('slick-initialized')) {
        $('.tech-role-slider').slick({
          rows: 4,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          speed: 4000,
          cssEase: 'linear',
          infinite: true,
          autoplaySpeed: 1,
          autoplay: true,
           responsive: [
              {
                breakpoint: 376,
                settings: {
                  slidesToShow: 1,
                }
                }
              ]
        });
      }
    } else {
      if ($('.tech-role-slider').hasClass('slick-initialized')) {
        $('.tech-role-slider').slick('unslick');
      }
    }
  }

  initializeSlider();

  $(window).resize(function() {
    initializeSlider();
  });
});


$(document).ready(function(){
  function initializeSlider() {
    if ($(window).width() <= 767) { 
      if (!$('.featured-sec-slider').hasClass('slick-initialized')) {
        $('.featured-sec-slider').slick({
          rows: 1,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          speed: 4000,
          cssEase: 'linear',
          infinite: true,
          autoplaySpeed: 1,
          autoplay: true,
           responsive: [
               {
                breakpoint: 576,
                settings: {
                  slidesToShow: 3,
                }
                },
                {
                breakpoint: 500,
                settings: {
                  slidesToShow: 2,
                }
                }
              ]
        });
      }
    } else {
      if ($('.featured-sec-slider').hasClass('slick-initialized')) {
        $('.featured-sec-slider').slick('unslick');
      }
    }
  }

  initializeSlider();

  $(window).resize(function() {
    initializeSlider();
  });
});


// Remove id from url
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetID = this.getAttribute('href');
        const targetEl = document.querySelector(targetID);
        if (targetEl) {
            targetEl.scrollIntoView({ behavior: 'smooth' });
        }
        setTimeout(() => {
            history.replaceState(null, null, ' ');
        }, 300);
    });
});


// Sticky header
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".custom-sticky-header");
  let lastScroll = 0;
  window.addEventListener("scroll", function () {
    let currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
      header.classList.remove("show");
      lastScroll = 0;
      return;
    }
    if (currentScroll < lastScroll) {
      header.classList.add("show");
    } else {
      header.classList.remove("show");
    }
    lastScroll = currentScroll;
  });
});